import clsx from 'clsx';

export default function Pill({ children }) {
  return (
    <p
      className={clsx(
        `my-auto inline-flex rounded-lg bg-blue-100 px-2 text-xl font-semibold leading-5 text-blue-800`
      )}
    >
      <span className="my-auto flex">{children}</span>
    </p>
  );
}
